<div class="modal-header" style="text-align: center; padding: 10px; border-bottom: 1px solid #dee2e6;">
  <h5 class="modal-title">Confirmation</h5>
</div>

<div class="modal-body confirmModal">
  <span style="font-size: 20px; margin-right: 8px;"> <i class="fa fa-exclamation-circle" style="margin-right: 8px; color: #ff9800;"></i></span>{{message}}
</div>

<div class="modal-footer"
  style="position: relative; background-color: transparent; border:0; display: block; text-align: center; padding-bottom: 10px">
  <button type="button" class="btn btn-primary smallBtn" (click)="SendResponse()" style="display:inline">Yes</button>
  <button type="button" class="btn btn-default smallBtn" (click)="bsModalRef.hide()" style="display:inline">No</button>
</div>